import { StyleSheet } from 'aphrodite';
import { borderColor, midGray, white } from '../../../../../web/styles/colors';

export const styleSheet = StyleSheet.create({
	dropdownMenu: {
		background: white,
		border: `1px solid ${borderColor}`,
		boxShadow: '0 0 6px 0 rgba(184,184,184,0.30)',
		marginTop: 21,
		maxHeight: 300,
		overflowY: 'auto',
		minWidth: '100%',
	},
	dropdownButton: {
		width: '100%',
	},
	menuItem: {
		':hover': {
			background: midGray,
		},
		cursor: 'pointer',
		fontSize: 14,
		fontWeight: 'normal',
		overflow: 'hidden',
		padding: 16,
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
	},
});
